import { useApp } from '../AppContext';
import FeedTab from '../tabs/FeedTab';
import ForgiveTab from '../tabs/ForgiveTab';
import FriendsTab from '../tabs/FriendsTab';
import ProfileTab from '../tabs/ProfileTab';
import InviteModal from '../components/InviteModal';
import './Main.css';

const TABS = [
  { id: 'feed',    icon: '📜', label: 'Tonight' },
  { id: 'forgive', icon: '🤲', label: 'Forgive'  },
  { id: 'friends', icon: '🌙', label: 'Circle'   },
];

export default function Main() {
  const { tab, setTab } = useApp();

  const panels = { feed: FeedTab, forgive: ForgiveTab, friends: FriendsTab, profile: ProfileTab };
  const ActivePanel = panels[tab] || FeedTab;

  return (
    <div className="main">
      <header className="main-header">
        <span className="main-logo">Mercy</span>
        <button className="icon-btn" onClick={() => setTab('profile')} title="Profile">☽</button>
      </header>

      <div className="main-content">
        <ActivePanel />
      </div>

      <nav className="tab-bar">
        {TABS.map(t => (
          <button
            key={t.id}
            className={`tab-btn${tab === t.id ? ' active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            <span className="tab-icon">{t.icon}</span>
            <span className="tab-label">{t.label}</span>
          </button>
        ))}
      </nav>

      <InviteModal />
    </div>
  );
}
